module.exports = __webpack_public_path__ + "static/media/peter-tester.525101fc.png";